import { useEffect } from 'react';
import { useSettingsStore } from '../store/tenantStore';
import { getPresetById } from '../config/themePresets';

/**
 * Dynamically updates the document title based on the active theme
 * Uses productName and tagline from theme configuration
 */
export function useDocumentTitle() {
  const settings = useSettingsStore((state) => state.settings);

  useEffect(() => {
    const activeTheme = getPresetById(settings?.colorTheme ?? '301io');
    
    // Set document title using dynamic branding
    const productName = activeTheme.productName || activeTheme.brandName || activeTheme.name;
    const tagline = activeTheme.tagline || '';
    const title = tagline ? `${productName} - ${tagline}` : productName;
    
    document.title = title;
  }, [settings?.colorTheme]);
}
